import React, { createContext, type PropsWithChildren, useContext } from 'react';

import type { CreateFlagArgs } from '@atlaskit/flag';

import { type TeamContainerType, type TeamData } from '../../ui/team-selector/types';

export type ExternalShowFlagFn = (args: CreateFlagArgs & { type?: 'success' | 'error' | 'info' | 'warning' }) => void;

export type TeamSelectorContextType = {
	cloudId: string;
	orgId: string;
	containerId: string;
	containerType?: TeamContainerType;
	onUpdateSuccess?: (params: { teamsConnected: TeamData[]; teamsDisconnected: TeamData[] }) => void;
	showFlag?: ExternalShowFlagFn;
};

const TeamSelectorContext = createContext<TeamSelectorContextType>({
	cloudId: '',
	orgId: '',
	containerId: '',
});

export function TeamSelectorProvider({
	children,
	cloudId,
	orgId,
	containerId,
	containerType,
	onUpdateSuccess,
	showFlag,
}: PropsWithChildren<TeamSelectorContextType>): React.JSX.Element {
	return (
		<TeamSelectorContext.Provider
			value={{
				cloudId,
				orgId,
				containerId,
				containerType,
				onUpdateSuccess,
				showFlag,
			}}
		>
			{children}
		</TeamSelectorContext.Provider>
	);
}

export const useTeamSelectorContext = (): TeamSelectorContextType =>
	useContext(TeamSelectorContext);
